<mat-toolbar style="margin-bottom: 20px; padding: 0 30px;">
  <div fxFlex fxLayout>
    <div style="margin-right: 15px;">
      <a routerLink="/home">
        <img alt="FAANG logo" src="../../../assets/FAANG_logo_RGBc.png" height="50" width="auto" class="d-inline-block align-top" />
      </a>
    </div>
    <button mat-button [mat-menu-trigger-for]="menu" fxHide="false" fxHide.gt-md>
      <mat-icon style="font-size: 30px;">menu</mat-icon>
    </button>
    <div fxFlex fxLayout fxHide.md fxHide.lt-md fxLayoutAlign="end center">
      <button mat-button>
        <a class="nav-link" routerLink="/home" routerLinkActive="active">Home</a>
      </button>
      <button mat-button [matMenuTriggerFor]="data">
        <a class="nav-link" [ngClass]="isActive('data')">Data
          <mat-icon style="vertical-align: middle;">arrow_drop_down</mat-icon>
        </a>
      </button>
      <button mat-button>
        <a class="nav-link" routerLink="/projects" routerLinkActive="active">Projects</a>
      </button>
      <button mat-button>
        <a class="nav-link" routerLink="/genome_browser" routerLinkActive="active">
          Genome Browser <sup>Beta</sup>
        </a>
      </button>
      <button mat-button [matMenuTriggerFor]="submit">
        <a class="nav-link" [ngClass]="isActive('submit')">Submit
          <mat-icon style="vertical-align: middle;">arrow_drop_down</mat-icon>
        </a>
      </button>
      <button mat-button>
        <a class="nav-link" routerLink="/ontology" routerLinkActive="active">
          Ontology Improver <sup>Beta</sup>
        </a>
      </button>
      <button mat-button [matMenuTriggerFor]="help">
        <a class="nav-link" [ngClass]="isActive('help')">Help
          <mat-icon style="vertical-align: middle;">arrow_drop_down</mat-icon>
        </a>
      </button>
      <button mat-button [matMenuTriggerFor]="search">
        <a class="nav-link" [ngClass]="isActive('search')">Search
          <mat-icon style="vertical-align: middle;">arrow_drop_down</mat-icon>
        </a>
      </button>
    </div>
  </div>
</mat-toolbar>

<!-- Navigation dropdown for medium and smaller screens -->
<mat-menu x-position="before" #menu="matMenu">
  <button mat-menu-item>
    <a class="nav-link" routerLink="/home" routerLinkActive="active">Home</a>
  </button>
  <button mat-menu-item [matMenuTriggerFor]="data">
    <a class="nav-link" [ngClass]="isActive('data')">Data
    </a>
  </button>
  <button mat-menu-item>
    <a class="nav-link" routerLink="/projects" routerLinkActive="active">Projects</a>
  </button>
  <button mat-menu-item>
    <a class="nav-link" routerLink="/summary" routerLinkActive="active">Summary</a>
  </button>
  <button mat-menu-item>
    <a class="nav-link" routerLink="/genome_browser" routerLinkActive="active">
      Genome Browser <sup>Beta</sup>
    </a>
  </button>
  <button mat-menu-item [matMenuTriggerFor]="submit">
    <a class="nav-link" [ngClass]="isActive('submit')">Submit
    </a>
  </button>
  <button mat-menu-item>
    <a class="nav-link" routerLink="/ontology" routerLinkActive="active">
      Ontology Improver <sup>Beta</sup>
    </a>
  </button>
  <button mat-menu-item [matMenuTriggerFor]="help">
    <a class="nav-link" [ngClass]="isActive('help')">Help
    </a>
  </button>
  <button mat-menu-item [matMenuTriggerFor]="search">
    <a class="nav-link" [ngClass]="isActive('search')">Search
    </a>
  </button>
</mat-menu>

<!-- Data Menu Dropdown -->
<mat-menu #data="matMenu">
  <button mat-menu-item>
    <a class="nav-link" routerLink="/organism" routerLinkActive="active">Organisms</a>
  </button>
  <button mat-menu-item>
    <a class="nav-link" routerLink="/specimen" routerLinkActive="active">Specimens</a>
  </button>
  <div class="dropdown-divider"></div>
  <button mat-menu-item>
    <a class="nav-link" routerLink="/dataset" routerLinkActive="active">Datasets</a>
  </button>
  <button mat-menu-item>
    <a class="nav-link" routerLink="/file" routerLinkActive="active">Files</a>
  </button>
  <div class="dropdown-divider"></div>
  <button mat-menu-item>
    <a class="nav-link" routerLink="/analysis" routerLinkActive="active">Analyses</a>
  </button>
  <div class="dropdown-divider"></div>
  <button mat-menu-item>
    <a class="nav-link" routerLink="/protocol/samples" [ngClass]="isActive('protocol')">Protocols</a>
  </button>
  <button mat-menu-item>
    <a class="nav-link" routerLink="/article" routerLinkActive="active">Publications</a>
  </button>
  <button mat-menu-item>
    <a class="nav-link" routerLink="/summary" routerLinkActive="active">Summary</a>
  </button>
</mat-menu>

<!-- Submit Menu Dropdown -->
<mat-menu #submit="matMenu">
  <button mat-menu-item>
    <a class="nav-link" routerLink="/ruleset/samples" fragment="Standard" [ngClass]="isActive('ruleset')">Rule sets</a>
  </button>
  <button mat-menu-item>
    <a class="nav-link" routerLink="/validation/samples" [ngClass]="isActive('validation')">Validation service</a>
  </button>
  <button mat-menu-item>
    <a class="nav-link" routerLink="/trackhubs" routerLinkActive="active">Track Hubs <sup>Beta</sup></a>
  </button>
  <button mat-menu-item>
    <a class="nav-link" routerLink="/nextflowSubmission" routerLinkActive="active">NextFlow files</a>
  </button>
  <div class="dropdown-divider"></div>
  <button mat-menu-item>
    <a class="nav-link" href="https://dcc-documentation.readthedocs.io/en/latest/"
       target="_blank" routerLinkActive="active">Help</a>
  </button>
</mat-menu>

<!-- Help Menu Dropdown -->
<mat-menu #help="matMenu">
  <button mat-menu-item>
    <a class="nav-link" href="https://dcc-documentation.readthedocs.io/en/latest/faq/" target="_blank">FAQ</a>
  </button>
  <button mat-menu-item>
    <a class="nav-link" routerLink="/api" routerLinkActive="active">API Documentation</a>
  </button>
</mat-menu>

<!-- Search Menu Dropdown -->
<mat-menu #search="matMenu">
  <button mat-menu-item>
    <a class="nav-link" routerLink="/graphql" routerLinkActive="active">Custom queries</a>
  </button>
  <button mat-menu-item>
    <a class="nav-link" routerLink="/globalsearch" routerLinkActive="active">Search</a>
  </button>
</mat-menu>
